import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import FallBack from "../Components/FallBack";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      redirect: false,
      isOnline: navigator.onLine,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  componentDidMount() {
    window.addEventListener("online", this.handleOnlineStatus);
    window.addEventListener("offline", this.handleOnlineStatus);
  }

  componentWillUnmount() {
    window.removeEventListener("online", this.handleOnlineStatus);
    window.removeEventListener("offline", this.handleOnlineStatus);
  }

  handleOnlineStatus = () => {
    this.setState({ isOnline: navigator.onLine });
  };

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isOnline && this.state.isOnline && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.isOnline) {
      return <FallBack />;
    }

    if (this.state.redirect) {
      return <Navigate to="/login" />;
    }

    if (this.state.hasError) {
      return <FallBack />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
